/**
 * Quotation Model - Processes API responses for quotation data
 */

export const getQuotations = (response) => {
  if (response && response.data && response.data.success === true) {
    const quotations = Array.isArray(response.data.data)
      ? response.data.data.map((q) => ({
          id: q.id,
          slack: q.slack,
          quotation_number: q.quotation_number,
          quotation_reference: q.quotation_reference,
          bill_to: q.bill_to,
          bill_to_id: q.bill_to_id,
          bill_to_code: q.bill_to_code,
          bill_to_name: q.bill_to_name,
          bill_to_email: q.bill_to_email,
          bill_to_contact: q.bill_to_contact,
          bill_to_address: q.bill_to_address,
          quotation_date: q.quotation_date,
          quotation_due_date: q.quotation_due_date,
          currency_code: q.currency_code,
          currency_name: q.currency_name,
          total_order_amount:
            q.total_order_amount || q.total_amount || q.amount,
          subtotal_excluding_tax: q.subtotal_excluding_tax,
          total_discount_amount: q.total_discount_amount,
          total_after_discount: q.total_after_discount,
          total_tax_amount: q.total_tax_amount,
          shipping_charge: q.shipping_charge,
          packing_charge: q.packing_charge,
          status: q.status,
          products: q.products || [],
          created_at: q.created_at,
          updated_at: q.updated_at,
          createdAt: q.createdAt || q.created_at,
          updatedAt: q.updatedAt || q.updated_at,
          created_by: q.created_by,
          updated_by: q.updated_by,
          created_user: q.created_user || null,
          updated_user: q.updated_user || null
        }))
      : []

    return {
      success: true,
      total: response.data.total || quotations.length,
      data: quotations
    }
  }
  return {
    success: false,
    message: response?.data?.message || 'Failed to fetch quotation list',
    data: []
  }
}

export const deleteQuotation = (response) => {
  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'Quotation deleted successfully'
    }
  }
  return {
    success: false,
    message: 'Failed to delete quotation'
  }
}

export const createQuotation = (response) => {
  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'Quotation created successfully',
      data: response.data.data || null
    }
  }
  return {
    success: false,
    message: 'Failed to create quotation',
    data: null
  }
}

export const updateQuotation = (response) => {
  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'Quotation updated successfully',
      data: response.data.data || null
    }
  }
  return {
    success: false,
    message: 'Failed to update quotation',
    data: null
  }
}
